import { useMemo, useState, type Dispatch, type SetStateAction } from 'react';
import { concat } from 'utils/array';
import type { components } from 'types/schemas/api-schema';

type Searchable = components['schemas']['NamedObject'];

const filterCollection = <T extends Searchable>(collection: T[], query: string): T[] => {
  if (query.length === 0 || !collection) {
    return collection;
  }
  // filter by name, description and labels
  return collection.filter((item) => {
    return concat([item.name || '', item.description || ''], item.labels || []).some(
      (label) => label.toLowerCase().indexOf(query.toLowerCase()) !== -1,
    );
  });
};

const useSearchFilter = <T extends Searchable>(
  collection: T[],
  customFilterFunction?: (collection: T[], query: string) => T[],
): [T[], Dispatch<SetStateAction<string>>] => {
  const [query, setQuery] = useState('');

  const filteredCollection = useMemo(() => {
    return (customFilterFunction || filterCollection)(collection, query);
  }, [collection, customFilterFunction, query]);

  return [filteredCollection, setQuery];
};

export default useSearchFilter;
